import React, { useState, useContext } from "react";
import { IconButton, Stack, Box } from "@mui/material";
//Icons
import { MdModeEdit, MdDelete } from "react-icons/md";
//Srcs
import "../../Style/actionstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import UpdateChartOfAccount from "./UpdateChartOfAccount";
import DeleteChartOfAccount from "./DeleteChartOfAccount";
import UpdateSubOne from "./UpdateSubOne";
import UpdateSubTwo from "./UpdateSubTwo";

export default function ChartOfAccountAction({
  actionType,
  editData,
  editDataSubOne,
  editDataSubTwo,
  setRefetch,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <IconButton onClick={handleOpenEdit}>
          <Box className="update-container">
            <MdModeEdit className="update-icon" />
          </Box>
        </IconButton>
        <IconButton onClick={handleOpenDelete}>
          <Box className="delete-container">
            <MdDelete className="delete-icon" />
          </Box>
        </IconButton>

        {actionType === "mainAction" ? (
          <UpdateChartOfAccount
            open={openEdit}
            handleClose={handleCloseEdit}
            editData={editData}
            setRefetch={setRefetch}
          />
        ) : actionType === "subActionOne" ? (
          <UpdateSubOne
            open={openEdit}
            handleClose={handleCloseEdit}
            editDataMain={editData}
            editDataSubOne={editDataSubOne}
            setRefetch={setRefetch}
          />
        ) : (
          <UpdateSubTwo
            open={openEdit}
            handleClose={handleCloseEdit}
            editDataMain={editData}
            editDataSubOne={editDataSubOne}
            editDataSubTwo={editDataSubTwo}
            setRefetch={setRefetch}
          />
        )}
        <DeleteChartOfAccount
          open={openDelete}
          handleClose={handleCloseDelete}
          editData={
            actionType === "mainAction"
              ? editData
              : actionType === "subActionOne"
              ? editDataSubOne
              : editDataSubTwo
          }
          setRefetch={setRefetch}
        />
      </Stack>
    </div>
  );
}
